module.exports = __webpack_public_path__ + "media/images/icons/fb-e1caf8d5e3d84a77edad5f8aa0fab999.svg";